import { Link } from 'react-router-dom'
import { HiArrowLeft } from 'react-icons/hi'
import './legal.css'

export default function TermsPage() {
  return (
    <div className="legal-page">
      <nav className="legal-nav">
        <Link to="/" className="legal-back">
          <HiArrowLeft />
          Back to Home
        </Link>
      </nav>

      <article className="legal-content">
        <h1>Terms of Service</h1>
        <p className="legal-updated">Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>

        <section>
          <h2>1. Agreement to Terms</h2>
          <p>
            By accessing or using StatScout ("the Service"), you agree to be bound by these Terms of Service.
            If you do not agree to these terms, please do not use the Service.
          </p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>
            StatScout is a football analytics platform that provides statistical data, probability models,
            and betting market analysis. The Service is intended for informational and entertainment purposes only.
          </p>
          <p>
            <strong>Important:</strong> StatScout does not provide gambling tips, betting advice, or guaranteed
            predictions. We provide data and analytics tools that users may use at their own discretion.
          </p>
        </section>

        <section>
          <h2>3. Eligibility</h2>
          <p>You must be at least 18 years old to use this Service. By using StatScout, you confirm that:</p>
          <ul>
            <li>You are at least 18 years of age</li>
            <li>You are legally permitted to gamble in your jurisdiction (if you choose to do so)</li>
            <li>You will comply with all applicable laws and regulations</li>
          </ul>
        </section>

        <section>
          <h2>4. Subscription and Payment</h2>
          <p>
            StatScout offers a subscription service at £7.95 per month, with a 7-day free trial for new users.
          </p>
          <ul>
            <li>Payment is processed securely through our payment provider (Stripe)</li>
            <li>Your subscription will automatically renew unless cancelled</li>
            <li>You may cancel at any time through your account settings</li>
            <li>A valid payment method is required to start your free trial</li>
          </ul>

          <h3>4.1 Cancellation Policy</h3>
          <p>
            If you cancel during your free trial, you will not be charged and your access will end
            immediately upon cancellation.
          </p>
          <p>
            If you cancel after payment has been taken, your subscription will remain active until
            the end of your current billing period. You will continue to have full access to StatScout
            until that date, after which your subscription will not renew and you will not be charged again.
          </p>
          <p>
            <strong>Example:</strong> If you are billed on the 1st of the month and cancel on the 15th,
            you will retain access until the end of that month (the 1st of the following month) and will
            not be charged for the next billing cycle.
          </p>

          <h3>4.2 Refunds</h3>
          <p>
            We do not provide refunds for partial billing periods. If you believe you have been charged
            in error, please contact us at <a href="mailto:support@statscout.io">support@statscout.io</a> within
            7 days of the charge.
          </p>
        </section>

        <section>
          <h2>5. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Share your account credentials with others</li>
            <li>Scrape, copy, or redistribute our data without permission</li>
            <li>Use the Service for any illegal purposes</li>
            <li>Attempt to reverse-engineer our algorithms or models</li>
            <li>Interfere with or disrupt the Service</li>
            <li>Use automated systems to access the Service without our consent</li>
          </ul>
        </section>

        <section>
          <h2>6. Intellectual Property</h2>
          <p>
            All content, features, and functionality of StatScout—including but not limited to the Dixon-Coles
            probability model implementation, user interface design, and analytical tools—are owned by StatScout
            and protected by copyright, trademark, and other intellectual property laws.
          </p>
        </section>

        <section>
          <h2>7. Disclaimer of Warranties</h2>
          <p>
            THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND. We do not guarantee:
          </p>
          <ul>
            <li>The accuracy or completeness of any data or predictions</li>
            <li>That the Service will be uninterrupted or error-free</li>
            <li>Any specific outcomes from using our analytics</li>
            <li>The accuracy of third-party data sources (odds, statistics, etc.)</li>
          </ul>
        </section>

        <section>
          <h2>8. Limitation of Liability</h2>
          <p>
            StatScout shall not be liable for any direct, indirect, incidental, special, or consequential
            damages resulting from your use of the Service, including but not limited to:
          </p>
          <ul>
            <li>Financial losses from gambling activities</li>
            <li>Decisions made based on our analytics or data</li>
            <li>Service interruptions or data inaccuracies</li>
          </ul>
          <p>
            <strong>You acknowledge that gambling involves risk and that you are solely responsible for
            your betting decisions.</strong>
          </p>
        </section>

        <section>
          <h2>9. Responsible Gambling</h2>
          <p>
            We encourage responsible gambling. If you or someone you know has a gambling problem,
            please contact:
          </p>
          <ul>
            <li><a href="https://www.begambleaware.org" target="_blank" rel="noopener noreferrer">BeGambleAware</a> - 0808 8020 133</li>
            <li><a href="https://www.gamcare.org.uk" target="_blank" rel="noopener noreferrer">GamCare</a> - 0808 8020 133</li>
            <li><a href="https://www.gamblingtherapy.org" target="_blank" rel="noopener noreferrer">Gambling Therapy</a></li>
          </ul>
        </section>

        <section>
          <h2>10. Termination</h2>
          <p>
            We reserve the right to suspend or terminate your account at any time for violation of these
            terms or for any other reason at our sole discretion.
          </p>
        </section>

        <section>
          <h2>11. Changes to Terms</h2>
          <p>
            We may update these Terms of Service from time to time. We will notify users of significant
            changes via email or through the Service. Continued use after changes constitutes acceptance
            of the new terms.
          </p>
        </section>

        <section>
          <h2>12. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of England and Wales,
            without regard to conflict of law principles.
          </p>
        </section>

        <section>
          <h2>13. Contact</h2>
          <p>
            For questions about these Terms of Service, please contact us at:
          </p>
          <p>
            <a href="mailto:support@statscout.io">support@statscout.io</a>
          </p>
        </section>
      </article>

      <footer className="legal-footer">
        <p>© {new Date().getFullYear()} StatScout. All rights reserved.</p>
      </footer>
    </div>
  )
}
